export default {
    data() {
        return {}
    },
    methods: {
        toHome: function() {
            var isLogin = sessionStorage.getItem("isLogin");
            var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            if (isLogin) {
                if (userInfo == null) {
                    this.$router.replace("/login");
                } else {
                    if (userInfo.userType==1) {
                        this.$router.replace("/console");
                    } else {
                        this.$message.closeAll();
                        this.$message.error("无权访问");
                    }
                }
            } else {
                this.$router.replace("/login");
            }
        }
    }
}